import WebSocketNotificationService from 'core/notification/WebSocketNotificationService';
import env from 'environment';

const service = new WebSocketNotificationService();

export default service;
